import moment from 'moment'
import { DateTimeFormatSimpleOnly } from './datetime'

export function RecentTimePrint(data: any) {
  const tenantName = data?.tenantName
  const datas: any[] = data?.dataList || []

  const colWidths = ['5%', '14%', '14%', '8%', '10%', '12%', '12%', '12%', '13%']

  let sjDatas = ''

  for (let i = 0; i < datas.length; i++) {
    const item = datas[i]
    const days = moment(item?.deadline).diff(moment(), 'days')

    sjDatas +=
      '<div style="font-size: 10px;display:table;width:100%;clear:left;border-right:1px solid #000;border-left:1px solid #000;border-bottom:1px solid #000">' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[0] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (i + 1) +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[1] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.name) +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[2] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.tenantSupplierName) +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[3] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.cabineNo) +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[4] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.batchNo) +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[5] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.deadline ? moment(item?.deadline).format(DateTimeFormatSimpleOnly) : '') +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[6] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.count) + ' ' + (item?.accountUnit || '') +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[7] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">' +
      '    ' + (item?.splitCount) + ' ' + (item?.splitUnit || '') +
      '  </div>' +
      '  <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[8] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box">' +
      '    ' + (days) + ' 天' +
      '  </div>' +
      '</div>'
  }

  const content =
    '<div style="margin-left:10px;margin-right:10px;font-family:\'宋体\';">' +
    '  <h2 style="text-align:center;margin-top:10px;margin-bottom:5px;font-weight:bold;">' +
    '    ' + (tenantName || '') + '近效期物资清单' +
    '  </h2>' +
    '  <div style="font-size:10px;display:table;width:100%;clear:left;border:1px solid #000;font-weight:bold;">' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[0] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">序号</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[1] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">物资信息</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[2] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">厂家</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[3] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">柜号</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[4] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">批次号</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[5] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">有效期至</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[6] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">库存数量</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[7] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box;border-right:1px solid #000">拆零数量</div>' +
    '    <div style="padding:4px 2px;word-break:break-all;width:' + colWidths[8] + ';display:table-cell;vertical-align:middle;text-align:center;box-sizing:border-box">剩余天数</div>' +
    '  </div>' +
    sjDatas +
    '</div>'

  return content
}